/* eslint no-console: 0 */
import Vue from 'vue';
import { cloneDeep, isEmpty, isEqual, isFunction, isNil } from 'lodash';
import { getToken, setToken, clearToken } from './token';

export default function customizeRouter($vm, router) {
  let ctrlTimer = null;

  let ctrlKeyPressed = false;
  $vm.$serviceBus.$on('keydown.ctrl', () => {
    ctrlKeyPressed = true;
    if (ctrlTimer !== null) {
      clearTimeout(ctrlTimer);
      ctrlTimer = null;
    } else {
      ctrlTimer = setTimeout(() => {
        ctrlKeyPressed = false;
      }, 30 * 1000);
    }
  });
  $vm.$serviceBus.$on('keyup.ctrl', () => {
    ctrlKeyPressed = false;
    if (ctrlTimer !== null) {
      clearTimeout(ctrlTimer);
      ctrlTimer = null;
    }
  });


  document.addEventListener('click', (e) => {
    if (!e.ctrlKey) {
      ctrlKeyPressed = false;
      if (ctrlTimer !== null) {
        clearTimeout(ctrlTimer);
        ctrlTimer = null;
      }
    }
  });

  router.afterEach((to, from) => {
    $vm.$serviceBus.$off('help.input.show');
    $vm.$serviceBus.$off('help.show');
    $vm.$serviceBus.$emit('navigatedTo', to.matched[0].components.default.name);

    try {
      Vue.rollbar.captureEvent('manual', {
        category: 'Navigation',
        action: `User navigated to page ${to.name}`,
        metadata: {
          name: to.name,
          path: to.path,
          query: to.query,
          params: to.params,
          fullPath: to.fullPath,
          meta: to.meta,
          url: window.location.href,
          hotel: $vm.hotel,
          user: $vm.$root.username,
          subdomain: isNil($vm.$store.getters['hotel/hotelSettings'])
          || isNil($vm.$store.getters['hotel/hotelSettings'].hotel)
          || isNil($vm.$store.getters['hotel/hotelSettings'].hotel.tenant) ? null : $vm.$store.getters['hotel/hotelSettings'].hotel.tenant.subdomain,
        },
      }, 'info');
      // eslint-disable-next-line no-empty
    } catch (ignore) {
      console.error(ignore);
    }

    try {
      if (!isNil(to) && !isNil(to.query) && Object.entries(to.query).filter(it => !isEmpty(it[0]) && !isEmpty(it[1]) && ['reload', 'token'].includes(it[0])).length > 0) {
        router.replace({
          ...to,
          query: {
            ...to.query,
            reload: undefined,
            token: undefined,
          },
        });
      }
    } catch (ignore) { /* ignore */ }
  });

  router.beforeEach((to, from, next) => {
    if (!isNil(to) && !isNil(to.meta)) {
      if (!isNil(to.meta.role) && !isEmpty(to.meta.role)) {
        if (!$vm.hasAnyRole(to.meta.role) && !$vm.hasRole('ROLE_SYSADMIN')) {
          $vm.$notify({
            group: 'msg',
            title: $vm.$t('messages.access_denied'),
            type: 'error',
            duration: 5000,
          });
          return;
        }
      }
      if (!isNil(to.meta.license) && !isEmpty(to.meta.license)) {
        if (isFunction($vm.hasAnyLicense) && !$vm.hasAnyLicense(to.meta.license)) {
          $vm.$notify({
            group: 'msg',
            title: $vm.$t('messages.access_denied'),
            type: 'error',
            duration: 5000,
          });
          return;
        }
      }
    }

    if (!isNil(to) && !isNil(from) && to.name === from.name && !isNil(to.name) && isEqual(to.params, from.params) && isEqual(to.query, from.query) && isEqual(to.meta, from.meta)) {
      return;
    }

    // required because document 'click' event is called after elements click event and we want to check if the ctrl key is still being pressed (especially if it was released outside the active window)
    setTimeout(() => {
      if (ctrlKeyPressed && (isNil(to.params) || to.params.sameWindow !== true)) {
        const newRoute = {
          name: to.name,
          params: cloneDeep(to.params),
          path: to.path,
          query: cloneDeep(to.query),
          meta: cloneDeep(to.meta),
        };
        if (isNil(newRoute.query)) newRoute.query = {};
        // newRoute.query.token = getToken(this.hotel);
        const routeURL = router.resolve(newRoute);
        window.open(routeURL.href, '_blank');
        return;
      }

      if ($vm.$store.getters['save/saveInProgress']) {
        $vm.$notify({
          group: 'msg',
          title: $vm.$t('app.saveInProgress.title'),
          text: $vm.$t('app.saveInProgress.text'),
          type: 'warn',
          duration: 3000,
        });
        return;
      }

      if (!isNil(to.query.token)) {
        setToken(to.params.hotelId, to.query.token);
      }

      if (isNil($vm.hotel) && !isNil(to.params.hotelId)) {
        $vm.hotel = to.params.hotelId;
      }

      if (to.name !== 'login') {
        $vm.testToken();
      }

      $vm.$serviceBus.$emit('closeNav', to);
      if (to.name !== 'login' && to.name !== 'hotels' && (isNil(getToken($vm.hotel)) || isNil($vm.hotel))) {
        next({ name: 'login' });
      } else if (to.name === 'login') {
        next();
      } else if (to.name !== 'hotels' && (isNil(to.params) || isNil(to.params.hotelId))) {
        to.params.hotelId = from.params.hotelId;
        next(to);
      } else {
        next();
      }
    }, 10);
  });
}



// WEBPACK FOOTER //
// ./src/lib/util/router.js